import { TableV2Column } from 'components/Table/TableV2';
import { RulesetItem } from '../types';
import { Box, Typography } from '@mui/material';
import { Paths } from 'services/navigation/paths';
import { formatDateFromNow } from 'utils/datetime';
import React from 'react';
import { RulesetSortField } from 'modules/analyse-rulesets/constants';
import { RouterLink } from 'common/ui/RouterLink';

export const getAnalyseRulesetsColumn = () => {
  const rulesetColumns: TableV2Column<RulesetItem>[] = [
    {
      id: RulesetSortField.NAME,
      name: 'Ruleset title',
      cell: (row) => (
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <RouterLink to={`${Paths.ANALYSE_RULESETS}/${row.id}`}>
            {row.name}
          </RouterLink>
        </Box>
      ),
      sortable: true,
      sortField: RulesetSortField.NAME,
      width: '50%',
      grow: 2
    },
    {
      id: RulesetSortField.UPDATED_AT,
      name: 'Last activity',
      sortField: RulesetSortField.UPDATED_AT,
      sortable: true,
      sortFunction: (a, b) => {
        return (
          new Date(b.updatedAt).getTime() - new Date(a.updatedAt).getTime()
        );
      },
      cell: (row) => formatDateFromNow(row.updatedAt),
      width: '25%'
    },
    {
      id: RulesetSortField.CREATED_BY,
      name: 'Created by',
      sortField: RulesetSortField.CREATED_BY,
      sortable: true,
      sortFunction: (a, b) => {
        const nameA = a.user?.name || '';
        const nameB = b.user?.name || '';
        return nameA.localeCompare(nameB);
      },
      cell: (row) => (
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center'
          }}
        >
          <Typography>{row.user?.name || ''}</Typography>
        </Box>
      ),
      width: '25%'
    }
  ];
  return rulesetColumns;
};
